/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Organization type
 */
export type OrganizationType =
  (typeof OrganizationType)[keyof typeof OrganizationType];

export const OrganizationType = {
  IME: "IME",
  LOGISTICS: "LOGISTICS",
  LEGAL: "LEGAL",
  FINANCE: "FINANCE",
  HOSPITALITY: "HOSPITALITY",
  ENERGY: "ENERGY",
  COMPENSATION: "COMPENSATION",
  CONSTRUCTIONS: "CONSTRUCTIONS",
  ADVERTISING: "ADVERTISING",
  COMMON: "COMMON",
  MANUFACTURING: "MANUFACTURING",
  ZONING: "ZONING",
  HEALTHCARE: "HEALTHCARE",
  ALLIED_HEALTH: "ALLIED_HEALTH",
  CLINICAL_SPECIALISTS: "CLINICAL_SPECIALISTS",
  LEGAL_HEALTH: "LEGAL_HEALTH",
  UNDERWRITING: "UNDERWRITING",
} as const;
